import { render, staticRenderFns } from "./SpotWidgetData.global.vue?vue&type=template&id=50b813ec&scoped=true&lang=pug&"
import script from "./SpotWidgetData.global.vue?vue&type=script&lang=ts&"
export * from "./SpotWidgetData.global.vue?vue&type=script&lang=ts&"
import style0 from "./SpotWidgetData.global.vue?vue&type=style&index=0&id=50b813ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b813ec",
  null
  
)

export default component.exports